// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3_4vN","fileBtn":"File_fileBtn__3OT6S","closeBtn":"File_closeBtn__2b2RR","fileSelected":"File_fileSelected__2eLmP","disabled":"File_disabled__2Br10"};